import type { ToastStore } from '@skeletonlabs/skeleton'
import camelcaseKeys from 'camelcase-keys'

import { handleFetch } from '@utils/fetch'

export interface LabelStudioConfig {
  enabled: boolean
}

let cachedConfig: LabelStudioConfig | null = null
let configPromise: Promise<LabelStudioConfig> | null = null
const disabledConfig: LabelStudioConfig = { enabled: false }

export const resetLabelStudioSessionState = () => {
  cachedConfig = null
  configPromise = null
}

export const getLabelStudioConfig = async (toastStore?: ToastStore): Promise<LabelStudioConfig> => {
  if (cachedConfig) {
    return cachedConfig
  }
  if (configPromise) {
    return configPromise
  }
  configPromise = (async () => {
    try {
      const response = await handleFetch('/label-studio/config', {}, undefined, toastStore)
      const parsed = camelcaseKeys(await response.json()) as LabelStudioConfig
      cachedConfig = parsed
      return parsed
    } catch (error) {
      console.error('[label-studio] Unable to load config, treating as disabled', error)
      return disabledConfig
    } finally {
      configPromise = null
    }
  })()
  return configPromise
}
